import React, { useState } from "react";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../assets/logo.png";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleContactClick = (e) => {
    e.preventDefault();
    window.open(
      "http://kverty.com/contact",
      "ContactPopup",
      "width=800,height=600,scrollbars=yes,resizable=yes"
    );
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const navItems = [
    { name: "Home", path: "/", icon: <HomeIcon fontSize="small" /> },
    { name: "Find Inverter", path: "/inverter", icon: <SearchIcon fontSize="small" /> },
    { name: "Contact", path: "external", icon: <PhoneIcon fontSize="small" /> },
  ];

  const styles = `
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@500;600;700&display=swap');

      * {
        font-family: 'Noto Sans', sans-serif;
      }

      .desktop-nav {
        display: flex;
      }

      .mobile-menu {
        display: none;
      }

      .mobile-menu-button {
        display: none;
      }

      /* Glassmorphism navigation items */
      .nav-item-glass {
        background: rgba(255, 255, 255, 0.15) !important;
        backdrop-filter: blur(15px) !important;
        -webkit-backdrop-filter: blur(15px) !important;
        border: 1px solid rgba(255, 255, 255, 0.25) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
      }

      .nav-item-glass:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        border: 1px solid rgba(255, 255, 255, 0.35) !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
        transform: translateY(-2px) !important;
      }

      @media (max-width: 900px) {
        .desktop-nav {
          display: none !important;
        }
        .mobile-menu-button {
          display: flex !important;
          align-items: center;
          justify-content: center;
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          border: 1px solid rgba(255,255,255,0.25);
          color: #fff;
          border-radius: 8px;
          width: 44px;
          height: 44px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .mobile-menu {
          display: ${mobileMenuOpen ? "flex" : "none"};
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: rgba(9, 135, 66, 0.47);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          flex-direction: column;
          padding: 1rem;
          box-shadow: 0 8px 25px rgba(0,0,0,0.25);
          border-top: 1px solid rgba(255,255,255,0.2);
        }
        .mobile-nav-item {
          padding: 1rem 1.2rem;
          margin: 0.3rem 0;
          border-radius: 12px;
          transition: all 0.3s ease;
          background: rgba(255,255,255,0.12);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,0.2);
          text-align: left;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .mobile-nav-item:hover {
          background: rgba(10, 47, 115, 0.8);
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          transform: translateX(8px);
          border: 1px solid rgba(255,255,255,0.3);
        }
      }
    </style>
  `;

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: styles }} />
      <header
        style={{
          background: " rgba(244, 244, 244, 0.47)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15), 0 0 0 1px rgba(255,255,255,0.1)",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <div
          className="header-container"
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "70px",
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
            onClick={() => setMobileMenuOpen(false)}
          >
            <img
              src={logo}
              alt="WattWise Logo"
              className="logo-icon"
              style={{
                width: "70px",   
                height: "70px",
                objectFit: "contain",
                filter: "brightness(1.3) contrast(1.5)", 
                dropShadow: "0 2px 8px rgba(0,0,0,0.2)",
              }}
            />
          </Link>

          <nav className="desktop-nav" style={{ gap: "0.5rem" }}>
            {navItems.map((item) =>
              item.name === "Contact" ? (
                <a
                  key={item.name}
                  href="http://kverty.com/contact"
                  onClick={handleContactClick}
                  style={navLinkStyle}
                  className="nav-item-glass"
                >
                  {item.icon}
                  {item.name}
                </a>
              ) : (
                <Link 
                  key={item.name} 
                  to={item.path} 
                  style={navLinkStyle}
                  className="nav-item-glass"
                >
                  {item.icon}
                  {item.name}
                </Link>
              )
            )}
          </nav>

          <button className="mobile-menu-button" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <CloseIcon fontSize="medium" /> : <MenuIcon fontSize="medium" />}
          </button>
        </div>

        <nav className="mobile-menu">
          {navItems.map((item) =>
            item.name === "Contact" ? (
              <a
                key={item.name}
                href="http://kverty.com/contact"
                onClick={handleContactClick}
                className="mobile-nav-item"
                style={mobileLinkStyle}
              >
                {item.icon}
                {item.name}
              </a>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className="mobile-nav-item"
                onClick={() => setMobileMenuOpen(false)}
                style={mobileLinkStyle}
              >
                {item.icon}
                {item.name}
              </Link>
            )
          )}
        </nav>
      </header>
    </>
  );
};

const navLinkStyle = {
  textDecoration: "none",
  color: "#0d9d63ff",
  padding: "0.6rem 1rem",
  borderRadius: "25px",
  transition: "all 0.3s ease",
  fontSize: "0.9rem",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  gap: "0.3rem",
  // Glass effect styles are applied via CSS class
};

const mobileLinkStyle = {
  textDecoration: "none",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "1rem",
  fontWeight: "600",
};

export default Header;